<div class="container pt-3">
  <div class="row justify-content-sm-center">
    <div class="col-sm-12 col-md-12 ">
      <div class="card border-info" style="background-color: #0275d8;">
        <div class="card-header" style="background-color: whitesmoke">Dove Siamo</div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-4 text-center">
              <img src="/assets/p2.jpg" style="width: 150px; length:150px">
            </div>
            <div class="col-md-8">
              <p>-Fit Active Torino</p>
              <p>  Via Giordano Bruno, 206 Torino (TO)</p>
              <p>-Air Sport Caselle</p>
              <p>  Via Torino 11 - Caselle Torinese (TO)</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

